import { useState, useContext, useEffect } from "react"
import { gql, useQuery } from "@apollo/client"

import { Field, useFormikContext } from "formik"

import { Dropdown } from "primereact/dropdown"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function StaffPrimarySupervisor({ field, block, index }) {
  const [supervisorList, setSupervisorList] = useState([])

  const defaultValue = { key: null, label: "Unassigned" }

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)

  useEffect(() => {
    if (!formik.values[field.field_name]) {
      formik.setFieldValue(field.field_name, defaultValue)
    }
  }, [])

  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const GET_SUPERVISORS = gql`
    query getSupervisors($staff_id: ID!, $organization_id: ID!) {
      supervisors: getStaffPrimarySupervisor(
        staff_id: $staff_id
        organization_id: $organization_id
      ) {
        key: staff_id
        label: staff_full_name
      }
    }
  `
  const { loading } = useQuery(GET_SUPERVISORS, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    onCompleted: ({ supervisors }) => {
      const supervisorList = [defaultValue, ...supervisors]
      setSupervisorList(supervisorList)
    },
    skip: !userCtx,
  })

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta, form }) => (
          <>
            <Dropdown
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={formikField.onChange}
              disabled={isDisabled}
              options={supervisorList}
              onBlur={(e) => formik.handleBlur(e)}
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
